
import {isIOS, requestWxstr} from '@/api/scanCode'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {load2, queryvirtualroomdevice} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'NewDevice',
components: {
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
showTips: false,
allHomeShow1: false,
allHomeShow: false,
showScene: false,
roomdevice: [], // 全部家庭\房间 以及下面的设备 接口queryvirtualroomdevice
showroomdevice: [],
roomDeviceList: [],
sceneId: '',
sceneActive: 0,
sceneData: [], // 所有返回的 家庭、房间
selectHome: '',
allHomeList: [],
selectHomeDeviceList: [],
mescroll: null, // mescroll实例对象
mescrollDown: {
autoShowLoading: true,
callback: this.upCallback,
dataList: [] 
}, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
defenceValue: false,


showDiv: false,
showHaveDevice: true,
showToast: false,

showAdd: false,
addText: '添加成功啦~',
addWarn: false,
warnText: '',






clickimg: true,
doorSuc: false,
doorText: '开门成功',
doorErr: false,
doorEtext: '',
defenceSuc: false,
defenceText: '布防成功',

showAddImg: true,


listData: [],

showDevice: [],
newtypesub: [],

showSub: [],
isShow: false,
imgArr: [
{dtype: 700, imgUrl: 'static/newDeviceIcon/index_gateway.png'}, // 安防智能网关 (网关)
{dtype: 400, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 门锁 (网关)
{dtype: 300, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // nb烟感
{dtype: 99, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // nb烟感
{dtype: 200, imgUrl: 'static/newDeviceIcon/index_police.png'}, // 一键报警
{dtype: 501, imgUrl: 'static/newDeviceIcon/index_CO.png'}, // 一氧化碳
{dtype: 502, imgUrl: 'static/newDeviceIcon/index_gas.png'}, // 燃气
{dtype: 800, imgUrl: 'static/newDeviceIcon/index_police_gateway.png'}, // 一键报警网关 (网关)
{dtype: 503, imgUrl: 'static/newDeviceIcon/index_fire.png'}, // 灭火器压力表
{dtype: 504, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁
{dtype: 505, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 巡鹰
{dtype: 506, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // NB-烟感新
{dtype: 507, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 西美
{dtype: 901, imgUrl: 'static/newDeviceIcon/index_W23.png'}, // Cat1 W23
{dtype: 902, imgUrl: 'static/newDeviceIcon/index_701SE.png'}, // Cat1 拉绳报警器

{dtype: -1, imgUrl: 'static/newDeviceIcon/second_alarmlamp.png'}, // 警灯
{dtype: 1, imgUrl: 'static/newDeviceIcon/index_CO.png'}, // 一氧化碳
{dtype: 2, imgUrl: 'static/newDeviceIcon/index_humiture_smoke.png'}, // 烟感
{dtype: 3, imgUrl: 'static/newDeviceIcon/index_gas.png'}, // 燃气
{dtype: 4, imgUrl: 'static/newDeviceIcon/second_door.png'}, // 门磁
{dtype: 5, imgUrl: 'static/newDeviceIcon/second_doorbell.png'}, // 门铃
{dtype: 6, imgUrl: 'static/newDeviceIcon/second_red.png'}, // 红外
{dtype: 7, imgUrl: 'static/newDeviceIcon/second_water.png'}, // 水浸
{dtype: 8, imgUrl: 'static/newDeviceIcon/second_control.png'}, // 遥控器
{dtype: 11, imgUrl: 'static/newDeviceIcon/index_humiture_smoke.png'}, // 温湿度烟感
{dtype: 12, imgUrl: 'static/newDeviceIcon/index_water.png'}, // 水压
{dtype: 13, imgUrl: 'static/newDeviceIcon/index_level.png'}, // 水位
{dtype: 51, imgUrl: 'static/newDeviceIcon/index_socket.png'}, // 智能开关
{dtype: 52, imgUrl: 'static/newDeviceIcon/index_humiture.png'}, // 温湿度
{dtype: 53, imgUrl: 'static/newDeviceIcon/second_lamp.png'}, // 智能灯泡
{dtype: 14, imgUrl: 'static/newDeviceIcon/second_door.png'}, // 门磁
{dtype: '', imgUrl: 'static/newDeviceIcon/index_default.png'} // 默认
],
etime: 0,
token: '',

addScene: false,
sceneName: '',
showDel: false,
childType: [2, 12, 13, 52, 11, 14],
isFirst: true
}
},
watch: {
},
mounted () {},
methods: {
nullMethod () {

},

openFamily () {
this.$router.push('/familyManagement')
},

selectHomeList (item) {

if (item.id !== this.selectHome.id) {
this.allHomeShow = false
this.selectHome = item
this.getEndData()
}
},

getSceneDevice (id) {
let device = ''
for (let i = 0; i < this.showDevice.length; i++) {
if (id === this.showDevice[i].id) {
device = this.showDevice[i]
}
}
return device
},

getAllShow (item) {
let scene = []

for (let i = 0; i < this.roomdevice.length; i++) {
if (this.roomdevice[i].parentid === item.id) {
let obj = this.roomdevice[i]
obj.nameShow = item.name + ' / ' + this.roomdevice[i].name
if (obj.devices !== null && obj.devices.length > 0) {
scene.push(obj)
}
} else if (this.roomdevice[i].id === item.id) { // 家庭本身
let obj = this.roomdevice[i]
obj.nameShow = this.roomdevice[i].name + ' / 未分组'
if (obj.devices !== null && obj.devices.length > 0) {
scene.push(obj)
}

}
}
for (let i = 0; i < scene.length; i++) {
let arr = []
if (scene[i].level === 1) {
if (scene[i].devices !== null) {
let devices = scene[i].devices
for (let j = 0; j < devices.length; j++) {
if (devices[j].areaid !== 0 && devices[j].roomid === 0) {
let obj = this.getSceneDevice(devices[j].did)
arr.push(obj)
}
}
}
} else {
if (scene[i].devices !== null) {
let devices = scene[i].devices
for (let j = 0; j < devices.length; j++) {
let obj = this.getSceneDevice(devices[j].did)
arr.push(obj)
}
}
}
scene[i].deviceList = arr
}
return scene
},

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {
let vm = this
this.listData = []
this.newtypesub = []
if (this.sceneId === '') { // 全部设备
this.showDevice = []
this.showSub = []
let cdata = []
load2().then(res => {
this.showDiv = false
let arr = res.data && res.data.devices !== null ? res.data.devices : []
if (arr.length === 0) {
this.showTips = true
}
for (let i = 0; i < arr.length; i++) {
if (arr[i].main_config !== '') {
arr[i].main_config = JSON.parse(arr[i].main_config)
while (typeof arr[i].main_config === 'string') {
arr[i].main_config = JSON.parse(arr[i].main_config)
}
}
arr[i].doorStatus = this.getOpenClose(arr[i].main_config)
if (arr[i].dtype === 400) {
arr[i].clickimg = true
cdata.push(arr[i])
} else {
if (arr[i].setting === null) {
arr[i].setting = [{value: 'off'}]
cdata.push(arr[i])
} else {
cdata.push(arr[i])
}
}
}
let subArr = []
let arr1 = res.data && res.data.data && res.data.data.newtypesub !== null ? res.data.data.newtypesub : []
for (let i = 0; i < arr1.length; i++) {
let obj = arr1[i]
obj.status = this.getSubDeviceStatus(arr1[i])
if (arr1[i].config !== '') {
obj.config = JSON.parse(arr1[i].config)
while (typeof obj.config === 'string') {
obj.config = JSON.parse(obj.config)
}
}
subArr.push(obj)
}
this.showDevice = cdata

this.showSub = subArr
if (this.isFirst) {
this.queryvirtualroomdevice()
} else {
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess()
}, 100)
})
this.getEndData()
}
}).catch(() => {
this.hashnext = false
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
} else { // 绑定场景设备
this.queryvirtualroomdevice()
}
},

queryvirtualroomdevice () {
let vm = this
queryvirtualroomdevice().then(res => {
this.isFirst = false
this.roomdevice = res.data && res.data.length > 0 ? res.data : ''
let aa = []
for (let i = 0; i < this.roomdevice.length; i++) {
if (this.roomdevice[i].role === 'owner') {
aa.push(this.roomdevice[i])
}
}
this.allHomeList = aa

for (let i = 0; i < this.roomdevice.length; i++) {

if (this.roomdevice[i].role !== 'owner' && this.roomdevice[i].parentid === 0) {
this.allHomeList.push(this.roomdevice[i])
}
}
let all = {name: '全部设备', id: 0}
let other = {name: '成员分享', id: -1}

let haveShare = false
for (let i = 0; i < this.showDevice.length; i++) {
if (this.showDevice[i].phonedevicerole === 'normal' || this.showDevice[i].phonedevicerole === '') { // 成员分享
haveShare = true
}
}
if (haveShare) {
this.allHomeList.push(other)
}
this.allHomeList.unshift(all)





if (this.selectHome === '') {
this.selectHome = this.allHomeList[0]
} else {
for (let i = 0; i < this.allHomeList.length; i++) {
if (this.selectHome.id === this.allHomeList[i].id) {
this.selectHome = this.allHomeList[i]
}
}
}
this.getEndData()
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess()
}, 100)
})
}).catch(() => {
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess()
}, 100)
})
})
},
getEndData () {
if (this.selectHome.id === 0) {

this.showHaveDevice = true
let allList = []
let deviceShare = []
let noBind = []
let unknown = []
for (let i = 0; i < this.showDevice.length; i++) {
if (this.showDevice[i].phonedevicerole === 'normal' || this.showDevice[i].phonedevicerole === '') { // 成员分享
if (this.showDevice[i].isonline === 0) {
deviceShare.push(this.showDevice[i])
} else {
deviceShare.unshift(this.showDevice[i])
}
} else if (this.showDevice[i].areaid === 0 && this.showDevice[i].roomid === 0) { // 默认场所
if (this.showDevice[i].isonline === 0) {
noBind.push(this.showDevice[i])
} else {
noBind.unshift(this.showDevice[i])
}
} else {

let isNoHaveRoom = true
for (let j = 0; j < this.roomdevice.length; j++) {
if (this.showDevice[i].areaid === this.roomdevice[j].id || this.showDevice[i].roomid === this.roomdevice[j].id) {
isNoHaveRoom = false
}
}
if (isNoHaveRoom) { // 有场所或者分组id但是找不到场所或分组 属于未知设备
unknown.push(this.showDevice[i])
}
}
}
for (let j = 0; j < this.allHomeList.length; j++) { // 场所 分组
if (this.allHomeList[j].id !== 0 && this.allHomeList[j].id !== -1 && this.allHomeList[j].id !== -3) {
let rooms = this.getAllShow(this.allHomeList[j])
allList = allList.concat(rooms)
}
}
if (deviceShare.length > 0) {
allList.push({nameShow: '成员分享', name: '成员分享', id: -1, deviceList: deviceShare})
}
if (noBind.length > 0) {
allList.unshift({nameShow: '默认场所', name: '未绑定', id: -2, deviceList: noBind})
}
if (unknown.length > 0) {
allList.push({nameShow: '未知设备', name: '未知设备', id: -4, deviceList: unknown})
}
let endArr = []
for (let i = 0; i < allList.length; i++) {
if (allList[i].deviceList.length > 0) {
endArr.push(allList[i])
}
}
this.listData = endArr

this.newtypesub = []
} else if (this.selectHome.id === -1) {

let arr = []
for (let i = 0; i < this.showDevice.length; i++) {
if (this.showDevice[i].phonedevicerole === 'normal' || this.showDevice[i].phonedevicerole === '') { // 成员分享
if (this.showDevice[i].isonline === 0) {
arr.push(this.showDevice[i])
} else {
arr.unshift(this.showDevice[i])
}
}
}
let list = [{nameShow: '成员分享', name: '成员分享', id: -1, deviceList: arr}]
this.listData = list
this.newtypesub = []
} else {

let scene = []
for (let i = 0; i < this.roomdevice.length; i++) {
if (this.roomdevice[i].parentid === this.selectHome.id) { // 场所下的分组
let obj = this.roomdevice[i]

obj.nameShow = this.roomdevice[i].name
if (obj.devices === null) {
scene.push(obj)
} else {
scene.unshift(obj)
}
} else if (this.roomdevice[i].id === this.selectHome.id) { // 场所本身
if (this.roomdevice[i].devices !== null) {
let obj = this.roomdevice[i]

obj.nameShow = '未分组'
if (obj.devices === null) {
scene.push(obj)
} else {
scene.unshift(obj)
}
}
}
}
for (let i = 0; i < scene.length; i++) {
let arr = []
if (scene[i].devices !== null) {
let devices = scene[i].devices
for (let j = 0; j < devices.length; j++) {
let obj = this.getSceneDevice(devices[j].did)
arr.push(obj)
}
}
scene[i].deviceList = arr
}
this.selectHomeDeviceList = scene

this.listData = this.selectHomeDeviceList
this.newtypesub = []
}
this.allHomeShow = false
if (this.listData.length === 0) {
this.showHaveDevice = false
} else {
this.showHaveDevice = true
}
},

getMPaName (pressure) {
return pressure / 1000000
},
getMPaName1 (config) {
let unit = ''

if (config.pressure_units === 0) {

unit = config.Press_Value / 1000
} else if (config.pressure_units === 1) {

unit = config.Press_Value
} else if (config.pressure_units === 2) {

unit = config.Press_Value * 100
} else if (config.pressure_units === 3) {

unit = config.Press_Value * 1000
} else {
return config.Press_Value
}
let MPa = this.getMPaName(unit)
return MPa + 'MPa'
},

getChildSwitch (val) {
if (val === '1') {
return '开启'
} else {
return '关闭'
}
},

sendZigbee (item, val) {
if (this.childType.indexOf(item.dtype) === -1) {

return
} else {
const stime = new Date(item.hearttime.replace(/-/g, '/')).getTime()
const etime = new Date().getTime()
const usedTime = etime - stime
const hours = Math.floor(usedTime / (3600 * 1000))
if (hours < 48) {} else {
return
}
}
let value = {
status: val
}
this.$http.post(this.base + 'sendcommandnewsub?token=' + this.$store.getters.get_token, {
did: item.pid,
subid: item.device_id,
iszigbee: item.config.iszigbee,
value: JSON.stringify(value)
}).then(res => {
if (res.data.code === 200) {
this.showAdd = true
this.addText = '成功'
this.upCallback()
} else {
if (res.data.code === 20001 || res.data.code === 20002 || res.data.code === 20003 || res.data.code === 20004 || res.data.code === 20007) {
this.golobleObject.getHintOpen(res)
} else {
this.addWarn = true
this.warnText = '失败'
}
}
}).catch(error => {
if (error.response.data.code === 20001 || error.response.data.code === 20002 ||
error.response.data.code === 20003 || error.response.data.code === 20004 ||
error.response.data.code === 20007 || error.response.data.code === 30006) {
this.golobleObject.getHintOpen(error.response.data)
} else {
this.addWarn = true
this.warnText = '失败'
}
})
},

getSubDeviceStatus (item) {





if (this.childType.indexOf(item.dtype) > -1) {

const stime = new Date(item.hearttime.replace(/-/g, '/')).getTime()
const etime = new Date().getTime()
const usedTime = etime - stime
const hours = Math.floor(usedTime / (3600 * 1000))
if (hours < 48) {
return 1
} else {
return 0
}
} else {
return 2
}
},

getChildIsonline (item) {
if (this.childType.indexOf(item.dtype) > -1) {

const stime = new Date(item.hearttime.replace(/-/g, '/')).getTime()
const etime = new Date().getTime()
const usedTime = etime - stime
const hours = Math.floor(usedTime / (3600 * 1000))
if (hours < 48) {
return 'item-div'
} else {
return 'item-div-active'
}
} else {
return 'item-div'
}
},

getIsonline (item) {

if (item.dtype !== 800) {
if (item.isonline === 1) {
return 'item-div'
} else {
return 'item-div-active'
}
} else {
return 'item-div'
}
},

changeDefence (item, index) {
this.$http.post(this.base + 'setdevice?token=' + this.$store.getters.get_token, {dids: [item.id],
properties: [{key: 'defence', value: item.setting[0].value}]}).then(res => {
if (res.data.code === 200) {
if (item.setting[0].value === 'on') {
this.showAdd = true
this.addText = '布防成功'
} else {
this.showAdd = true
this.addText = '撤防成功'
}
} else {
if (res.data.code === 20001 || res.data.code === 20002 || res.data.code === 20003 || res.data.code === 20004 || res.data.code === 20007) {
this.golobleObject.getHintOpen(res)
} else {
if (item.setting[0].value === 'on') {
this.addWarn = true
this.warnText = '布防失败'
} else {
this.addWarn = true
this.warnText = '撤防失败'
}
this.upCallback()
}
}
}).catch(error => {
if (error.response.data.code === 20001 || error.response.data.code === 20002 ||
error.response.data.code === 20003 || error.response.data.code === 20004 ||
error.response.data.code === 20007 || error.response.data.code === 30006) {
this.golobleObject.getHintOpen(error.response.data)
} else {
this.addWarn = true
this.warnText = '布防失败'
this.upCallback()
}
})
},

openChild (item) {
this.$store.commit('set_child_obj', item)
this.$router.push('/NewChildList')
},

childOpenChild (item) {
if (item.dtype === 2 ||
item.dtype === 11 ||
item.dtype === 12 ||
item.dtype === 13 ||
item.dtype === 51 ||
item.dtype === 52) {
this.$store.commit('set_sub_device', item)
this.$router.push('/secondView')
} else {
for (let i = 0; i < this.listData.length; i++) {
if (parseInt(item.pid) === parseInt(this.listData[i].id)) {
this.$store.commit('set_child_obj', this.listData[i])
this.$router.push('/NewChildList')
}
}
}
},

openMap (item) {
this.$store.commit('set_child_obj', item)
if (item.dtype === 99 || item.dtype === 300) {
this.$router.push({path: '/AmapNB', query: {Imei: item.deviceid}})
} else if (item.dtype === 901) {
this.$router.push({path: '/mapCat', query: {Imei: item.deviceid}})
}
},

getImageUrl (dtype) {
let key = parseInt(dtype)
let imgdata = this.imgArr
let img = imgdata[this.imgArr.length - 1].imgUrl
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
img = imgdata[i].imgUrl
}
}
return img
},

openChangeNew (item, index) {
if (item.isonline === 0) {
return
}
let id = item.id
this.listData[index].clickimg = false
this.$http.post(this.base + 'sendcommandlock?token=' + this.$store.getters.get_token, {did: id, cmd: 'openlock', value: '1'}).then(res => {
if (res.data.code === 200) {
this.doorSuc = true
this.listData[index].clickimg = true
} else {
if (res.data.code === 20001 || res.data.code === 20002 || res.data.code === 20003 || res.data.code === 20004 || res.data.code === 20007) {
this.golobleObject.getHintOpen(res)
} else {
this.doorEtext = res.data.msg
this.doorErr = true
}
}
}).catch(error => {
if (error.response.data.code === 20001 || error.response.data.code === 20002 ||
error.response.data.code === 20003 || error.response.data.code === 20004 ||
error.response.data.code === 20007 || error.response.data.code === 30006) {
this.golobleObject.getHintOpen(error.response.data)
} else {
this.doorEtext = '开门失败'
this.doorErr = true
this.listData[index].clickimg = true
}
})
},

getSubMainName (item) {
for (let i = 0; i < this.showDevice.length; i++) {
if (parseInt(item.pid) === parseInt(this.showDevice[i].id)) {
return this.showDevice[i].name
}
}
},

getDefenceState (obj) {
for (let i = 0; i < this.listData.length; i++) {
if (parseInt(obj.deviceId) === this.listData[i].id && this.listData[i].setting[0].value !== obj.value) {
this.upCallback()
}
}
},

openAllHome () {

this.allHomeShow = true
},

getOpenClose (config) {
let name = ''
if (config.passthrough) {
let num = config.passthrough + ''
let val = num.slice(0, 1)
if (val === '0') {
name = '关门'
} else if (val === '1') {
name = '开门'
}
}
return name
},

changeDoorStatus (obj) {

for (let i = 0; i < this.showDevice.length; i++) {
if (obj.device_id === this.showDevice[i].deviceid) {
this.showDevice[i].unhandlealarm += 1
}
if (this.listData[i]) {
if (obj.device_id === this.listData[i].deviceid) {
this.listData[i].unhandlealarm += 1
if (obj.alarmtype === 'doorclose') {
this.listData[i].doorStatus = '关门'
} else if (obj.alarmtype === 'dooropen') {
this.listData[i].doorStatus = '开门'
}
}
}
}
}
},
created () {
this.golobleObject.getMqttDoor = this.changeDoorStatus
this.token = this.$store.getters.get_token
this.etime = Date.parse(new Date())
this.golobleObject.defenceState = this.getDefenceState
this.golobleObject.addDeviceLoad = this.upCallback
if (this.isWx()) {
if (!isIOS()) {
requestWxstr()
}
} else {
this.showAddImg = false
}
},
computed: {
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewDevice.vue